import type { EntityType as PluralEntityType } from "@/types/entity";

const SINGULAR_TO_PLURAL = {
  account: "accounts",
  opportunity: "opportunities",
  campaign: "campaigns",
} as const;

export type SingularEntityType = keyof typeof SINGULAR_TO_PLURAL;

export function toPluralEntityType(
  singular: SingularEntityType,
): PluralEntityType {
  return SINGULAR_TO_PLURAL[singular];
}
